import { createFileRoute } from '@tanstack/react-router';

import { PayrollRunPage } from '@/features/workforce/payroll-run-page';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/payroll/$runId')({
  component: PayrollRunRoute,
});

function PayrollRunRoute() {
  const { projectId, runId } = Route.useParams();
  return <PayrollRunPage projectId={projectId} runId={runId} />;
}
